import { BI_DIMENSIONS, type BiDimensionValues } from './bi-constants';
import { PatientFormsContext } from '../state-machine/patient-forms.types';

export interface SaveDimensions extends Record<string, string> {
	[BI_DIMENSIONS.toggle]: BiDimensionValues[typeof BI_DIMENSIONS.toggle];
	[BI_DIMENSIONS.iteroPatientStatus]: BiDimensionValues[typeof BI_DIMENSIONS.iteroPatientStatus];
	[BI_DIMENSIONS.invisalignPatientStatus]: BiDimensionValues[typeof BI_DIMENSIONS.invisalignPatientStatus];
	[BI_DIMENSIONS.linkageStatus]: BiDimensionValues[typeof BI_DIMENSIONS.linkageStatus];
}

export const buildSaveDimensions = (context: PatientFormsContext, stateMatches: (path: string) => boolean): SaveDimensions => {
	const iTeroPatient = context.iTeroPatient;
	const isNew = !iTeroPatient?.id;
	const isAlreadyLinked = iTeroPatient?.system === 'both';
	const hasInvisalignSelected = stateMatches('patientCard.invisalignPatient.selected');
	const hasInvisalignCreating = stateMatches('patientCard.invisalignPatient.creating');
	const needsLinking = !isAlreadyLinked && (hasInvisalignSelected || hasInvisalignCreating);
	const isToggleHidden = isAlreadyLinked || hasInvisalignSelected;

	let invisalignStatus: BiDimensionValues[typeof BI_DIMENSIONS.invisalignPatientStatus];

	if (isAlreadyLinked || hasInvisalignSelected) {
		invisalignStatus = 'existing';
	} else if (hasInvisalignCreating || context.invisalignToggle) {
		invisalignStatus = 'new';
	} else {
		invisalignStatus = 'not-relevant';
	}

	let linkageStatus: BiDimensionValues[typeof BI_DIMENSIONS.linkageStatus];

	if (isAlreadyLinked) {
		linkageStatus = 'existing';
	} else if (needsLinking) {
		linkageStatus = 'new';
	} else {
		linkageStatus = 'none';
	}

	return {
		[BI_DIMENSIONS.toggle]: isToggleHidden ? 'hidden' : context.invisalignToggle ? 'on' : 'off',
		[BI_DIMENSIONS.iteroPatientStatus]: isNew ? 'new' : 'existing',
		[BI_DIMENSIONS.invisalignPatientStatus]: invisalignStatus,
		[BI_DIMENSIONS.linkageStatus]: linkageStatus
	};
};
